<template>
  <div>
    <v-dialog v-model="showCreate" scrollable persistent max-width="600">
      <v-card color="white" elevation="0" width="100" height="auto">
        <v-card-title class="w-100">
          <v-spacer></v-spacer>
          <h4>افزودن برد</h4>
          <v-spacer></v-spacer>
          <v-btn @click="closeCreate" text rounded>
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-text-field
              outlined
              label="نام برد"
              v-model="name"
              :error-messages="getErrorMessage('name')"
          ></v-text-field>

          <v-text-field
              outlined
              label="کد"
              v-model="code"
              :error-messages="getErrorMessage('code')"
          ></v-text-field>

          <v-divider class="mx-5 my-5"></v-divider>
          <h3>سنسور‌ها :</h3>
          <div class="mx-xl-15 mx-lg-10 mx-xxl-auto pt-5">
            <v-list style="max-height: 300px" class="overflow-y-auto">
              <v-row style="padding: 0; margin: 0;" v-for="(device, index) in devices" :key="index">
                <v-col cols="1">
                  <div class="mt-3 text-center" style="font-size: 16px;display: grid">{{ index + 1 }}.</div>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                      dense hide-details filled
                      v-model="devices[index]['name']"
                      placeholder="نام نمایشی "
                      @keyup="addNewRow(index, devices)"
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <div class="mt-3 text-center" style="font-size: 30px;color: red">:</div>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                      dense hide-details filled
                      v-model="devices[index]['value']"
                      placeholder="نام ارسالی از برد"
                      @keyup="addNewRow(index, devices)"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-list>
          </div>

          <v-divider class="mx-2 my-5"></v-divider>
          <h3>رله ها :</h3>
          <div class="mx-xl-15 mx-lg-10 mx-xxl-auto pt-5">
            <v-list style="max-height: 300px" class="overflow-y-auto">
              <v-row style="padding: 0; margin: 0;" v-for="(device, index) in relays" :key="index">
                <v-col cols="1">
                  <div class="mt-3 text-center" style="font-size: 16px;display: grid">{{ index + 1 }}.</div>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                      dense hide-details filled
                      v-model="relays[index]['name']"
                      placeholder="نام نمایشی "
                      @keyup="addNewRow(index, relays)"
                  ></v-text-field>
                </v-col>
                <v-col cols="1">
                  <div class="mt-3 text-center" style="font-size: 30px;color: red">:</div>
                </v-col>
                <v-col cols="5">
                  <v-text-field
                      dense hide-details filled
                      v-model="relays[index]['value']"
                      placeholder="نام ارسالی از برد"
                      @keyup="addNewRow(index, relays)"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-list>
          </div>

          <v-sheet class="container" style="border: 1px rgba(0,0,0,0.2) solid" rounded>
            <div class="row">
              <h3 class="mr-5 my-auto">
                توضیحات
              </h3>
              <v-spacer></v-spacer>
              <div>
                <v-btn icon @click="des_show=!des_show">
                  <v-icon v-if="des_show">
                    mdi-arrow-up-drop-circle
                  </v-icon>
                  <v-icon v-else>
                    mdi-arrow-down-drop-circle
                  </v-icon>
                </v-btn>
              </div>
            </div>
            <v-textarea
                v-if="des_show" dense
                hide-details
                class="mt-5"
                v-model="descriptions"
                placeholder="افزودن توضیحات برد در صورت نیاز..."
            ></v-textarea>
          </v-sheet>
        </v-card-text>

        <v-card-actions>
          <v-col cols="12">
            <v-btn block large class="elevation-0 text-bold" color="success" @click="sendBoard" :loading="btn_loading">
              ثبت
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "BoardCreate",
  props: ['showCreate'],

  data: () => ({
    key: localStorage.getItem('key'),
    devices: [{ name: null, value: null }],
    relays: [{ name: null, value: null }],
    name: null,
    code: null,
    descriptions: null,
    errors: {},
    btn_loading: false,
    des_show: false,
  }),

  methods: {
    addNewRow(index, model) {
      if(model.length === index+1){
        if(model[index].name && model[index].value){
          model.push({name:null, value:null})
        }
      }else{
        if(!model[index].name && !model[index].value){
          if(!model[index].name && !model[index].value){
            this.$delete(model, index);
          }else{
            model.pop();
          }
        }
      }
    },

    getErrorMessage(field) {
      if(this.errors){
        return this.errors[field] ? this.errors[field][0] : false;
      }
      return false
    },

    async sendBoard() {
      if (this.devices.length > 1 && this.relays.length > 1) {
        this.btn_loading = true;
        this.devices.pop();
        this.relays.pop();
        try {
          await axios
              .post(`${this.BACKEND_LINK}/api/devices-data/boards/`, {
                devices: this.devices,
                relays: this.relays,
                name: this.name,
                code: this.code,
                sets: [],
                descriptions: this.descriptions
              }, {
                headers: {'Authorization': `Token ${this.key}`}
              })
              .then(() => {
                this.$snotify.success('اطلاعات با موفقیت ثبت شد.');
                this.devices = [{name: null, value: null}];
                this.name = null;
                this.code = null;
                this.descriptions = null;
                this.closeCreate()
              })
              .catch((errors) => {
                if (errors.response.data) {
                  this.errors = errors.response.data
                }
                this.$snotify.error(`خطا در ثبت اطلاعات `);
                this.devices.push({name: null, value: null});
              })
              .finally(() => {
                this.btn_loading = false;
              })
        } catch (error) {
          this.$snotify.error(`خطا در ثبت اطلاعات : ${error}`);
          this.btn_loading = false;
          this.devices.push({name: null, value: null});
        }
      } else {
        this.$snotify.error(`حداقل یک سنسور اضافه کنید`);
      }
    },

    closeCreate() {
      this.showCreate = false;
      this.$emit('close');
    },
  },
};
</script>
